/*-------------------------------------------------------------------------------------------------------------------
about：此文件是天猫精灵的一些方法
author：马兆铿
date：2017-11-14
* -------------------------------------------------------------------------------------------------------------------*/

/*  设置标题需要添加全局监听事件
* */
document.addEventListener('exit', function (e) {
  window.WindVane && window.WindVane.call('AppModel', 'finishCurrentPage', {},
    function (result) {
      //alert(result);
    },
    function (e) {
    });
}, false);

//天猫精灵的功能函数对象类
class WindVane {
  /*  设置导航栏标题
  * */
  setNavTitle(data) {
    if (!window.WindVane) return;
    window.WindVane && window.WindVane.call('AppModel', 'setNavBar', {
      center: {
        text: data
      },
      right: [{
        type: 'text',
        content: '退出',
        eventName: 'exit',
      },]
    }); //天猫的设置标题
  }

  /*  升级天猫精灵
  * */
  toUpdateApp() {
    if (!window.WindVane) return;
    if (
      /Windows\s(Phone(?:\sOS)?|NT)\s[\d\.]+/i.test(
        window.navigator.userAgent
      )
    ) {
      console.log("当前运行环境是 Windows 客户端");
    } else if (/iPhone|iPad|iPod/i.test(window.navigator.userAgent)) {
      window.location.href =
        "https://itunes.apple.com/cn/app/%E5%A4%A9%E7%8C%AB%E7%B2%BE%E7%81%B5/id1158753204?mt=8";
    } else if (/Android/i.test(window.navigator.userAgent)) {
      window.location.href =
        "http://www.wandoujia.com/apps/com.alibaba.ailabs.tg";
    }
  }

  /*  检查sdk版本
  * */
  sdkVersionCheck() {
    if (!window.WindVane) return;
    /**@name 是否启用入网功能 */
    const verifyDevAccess = () => {
      const ua = window.navigator.userAgent.toLowerCase();
      let tgenieArr = ua.match(/\(tgenie\/(.+)\)/);
      if (tgenieArr) {
        const sdkNum = tgenieArr[1];
        const sdkNumArr = sdkNum.split(".");
        const first = sdkNumArr[0];
        const second = sdkNumArr[1];
        if (parseInt(first) == 2) {
          if (second >= 7) {
            return true;
          } else {
            return false;
          }
        } else if (parseInt(first) > 2) {
          return true;
        } else {
          return false;
        }
      }
    };

    if (
      /Windows\s(Phone(?:\sOS)?|NT)\s[\d\.]+/i.test(
        window.navigator.userAgent
      )
    ) {
    } else if (/iPhone|iPad|iPod/i.test(window.navigator.userAgent)) {
      this.isAddDevAccess = verifyDevAccess();
    } else if (/Android/i.test(window.navigator.userAgent)) {
      this.isAddDevAccess = verifyDevAccess();
    }
  }

  /*  获取当前wifi
  * @return {string}当前wifi的名字
  * */
  getCurrentWifi() {
    return new Promise((resolve, reject) => {
      if (!window.WindVane) reject();
      //获取当前wifi
      window.WindVane.call("At", "getSSID", {}, function (obj) {
        //alert(obj.result);//当 obj.result 为""时说明没有连接 wifi
        const wifiName = obj.result;
        resolve(wifiName);
      }, function (res) {
        reject(res);
      });
    });
  }

  /*  解除天猫精灵绑定账号，需要重新登录
  * */
  unbind() {
    if (!window.WindVane) return;
    window.WindVane.call('Broadlink', 'unbind', {
      skillId: "1213"
    }, function (obj) {
      alert(obj.result);
      window.WindVane && window.WindVane.call('AppModel', 'finishCurrentPage', {},
        function (result) {
          // alert(result);
        },
        function (e) {
        });
    }, function (e) {
      alert('failure: ' + JSON.stringify(e));
    });
  }

  /*  链接wifi设备
  * */
  connectDevice() {
    if (!window.WindVane) return;
    return new Promise((resolve, reject) => {
      window.WindVane.call(
        "HomeMate",
        "connect",
        {}, function (res) {
          resolve(res);
        },
        function (res) {
          reject(res)
        });
    });
  }

  /*  向wifi设备发送消息
  * */
  sendMessage(msg) {
    if (!window.WindVane) return;
    return new Promise((resolve, reject) => {
      window.WindVane.call(
        "HomeMate",
        "send",
        msg,
        function (res) {
          resolve(res);
        },
        function (res) {
          reject(res)
        });
    });
  }

  /*  根据经纬度获取地理位置
  * */
  getLocation() {
    if (!window.WindVane) return;
    return new Promise((resolve, reject) => {
      window.WindVane.call(
        "AppModel",
        "getLocation",
        {},
        function (res) {
          resolve(res);
        },
        function (e) {
          reject(e);
        }
      );
    });
  }

  /*  退出App
  * */
  exitApp() {
    if (!window.WindVane) return;
    window.WindVane.call('AppModel', 'finishCurrentPage', {},
      function (result) {
      },
      function (e) {
      });
  }
}

export const windVane = new WindVane();

import { getPlaceList } from '../api'

//阿里的多次复用数据，可以保存在内存中
class Aligenie {
  constructor() {
    this.roomList = [];
  }

  /*  获取支持的房间的名字
  * */
  getRoomList() {
    return new Promise(resolve => {
      if (this.roomList.length > 0) {  //已经有的话不必再获取
        resolve();
      } else {
        getPlaceList().then(res => {
          if (res.success) {
            this.roomList = res.data;
            resolve();
          } else {
            alert('网络错误');
          }
        });
      }
    });
  }

  /*  获取房间名字
  * @param {str}aligenieZone阿里的房间名字 {str}roomName 365的房间名字
  * */
  getRoomName(aligenieZone, roomName) {
    if (aligenieZone) { //优先显示阿里的房间
      return aligenieZone;
    } else if (roomName) {  //没有阿里的话，如果365的与阿里一致，也显示
      if (this.roomList.find(item => item === roomName)) {
        return roomName;
      }
    }
    return '未设置房间';
  }
}

export const aligenie = new Aligenie();


// WEBPACK FOOTER //
// ./src/utils/tmallGenius.js